module.exports = __webpack_public_path__ + "f0dc7cee0e5b321aa3981c97e9bd252d.pdf";